import { observable } from "mobx";
import AccountBalanceCheckResultDownloadActionRejectionReason from "./accountBalanceCheckResultDownloadActionRejectionReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountBalanceCheckResultDownloadActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: AccountBalanceCheckResultDownloadActionRejectionReason;
}
